export const PATHNAME = {
        ADMIN_UNIT_REGION: '/unit-region',
        ADMIN_UNIT_REGION_DETAILS: '/unit-region/:unitRegionName',
        ADMIN_OPERATING: '/unit-region/:unitRegionName/unit-operating',
        ADMIN_PROJECT_DETAILS: '/unit-region/:unitRegionName/project-details',
        ADMIN_UNIT_REGION_FINAL_PREVIEW: '/unit-region/:unitRegionName/:unitRegionProject',
        ADMIN_ACTIVE_PROJECTS: '/projects/monitoring-projects',
        ADMIN_ACTIVE_PROJECTS_DATA_SUBMISSION_STATUS: '/projects/monitoring-projects/data-submission-status',
        ADMIN_OTHER_PROJECTS_DATA_SUBMISSION_STATUS: '/projects-other-projects/data-submission-status',
        ADMIN_MONITORING_PROJECTS_DATA_FILLED_STATUS: '/unit-project-filled-status',
        ADMIN_OTHER_PROJECTS_DATA_FILLED_STATUS: '/other-project-filled-status',
        ADMIN_ACTIVE_PROJECT_DETAILS: '/projects/monitoring-projects',
        ADMIN_ACTIVE_PROJECT_UNIT_DETAIL: '/projects/monitoring-projects/project-item/project-name',
        ADMIN_ALL_PROJECTS: '/projects/all-projects',
        ADMIN_DASHBOARD: '/dashboard',
        ADMIN_DIRECT_ORDERS: '/projects-direct-orders',
        ADMIN_ANTICIPATED_ORDERS: '/projects-anticipated-orders',
        ADMIN_OTHER_PROJECTS: '/projects-other-projects',
        ADMIN_OTHER_PROJECTS_DETAILS: '/projects-other-projects-details',
        ADMIN_PROJECT_CUSTOMER_GROUP_WISE: '/projects-customer-group-wise',
        ADMIN_REPORTS: '/reports',
        ADMIN_UNIT_LEVEL_REPORT: '/reports/unit-level',
        ADMIN_UPLOAD_CSV_FILES_INTERNAL_ORDER_MASTER: '/internal-order-master/upload-csv',
        ADMIN_UPLOAD_CSV_FILES_IO_INDAS_DATA_MAPPING: '/io-indas-data-mapping/upload-csv',
        ADMIN_UPLOAD_CSV_FILES_IO_UNIT_MAPPING: '/io-unit-mapping/upload-csv',
        ADMIN_UPLOAD_CSV_FILES_IO_ALLOCATION: '/io-allocation/upload-csv',
        ADMIN_PROJECT_LEVEL_REPORT: '/reports/project-level',
        ADMIN_CONSOLIDATED_PROJECT_WISE_REPORT : '/consolidatedreports/project-wise-report',
        ADMIN_CONSOLIDATED_UNIT_WISE_REPORT : '/consolidatedreports/unit-wise-report',
        ADMIN_CONSOLIDATED_IUT_REPORT : '/consolidatedreports/iut-report',
        ADMIN_CONSOLIDATED_IUT_NON_BHEL_REPORT : '/consolidatedreports/iut-non-bhel-report',
        ADMIN_CONSOLIDATED_YEARLY_CHART : '/consolidatedreports/yearly-charts',
        ADMIN_CONSOLIDATED_QUARTERLY_CHART : '/consolidatedreports/quarterly-charts',
        ADMIN_CONSOLIDATED_BUDGET_REPORT : '/consolidatedreports/budget-report',
        ADMIN_CONSOLIDATED_ACTUAL_BUDGET_REPORT : '/consolidatedreports/actual-budget-report',
        ADMIN_CONSOLIDATED_OPERATING_PERFORMANCE_REPORT : '/operating-performance-report',
        ADMIN_CONSOLIDATED_OPERATING_PERFORMANCE_UNITWISE_REPORT : '/operating-performance-unit-wise-report',
        ADMIN_CONSOLIDATED_OPERATING_PERFORMANCE_QUARTERWISE_REPORT : '/operating-performance-quarter-wise-report',
        ADMIN_CONSOLIDATED_EXECUTION_REPORT : '/consolidatedreports/execution-plan',
        ADMIN_CONSOLIDATED_EXECUTION_REPORT_NEW : '/consolidatedreports/execution-plan-new',
        ADMIN_CONSOLIDATED_ORDER_OUTSTANDING : '/consolidatedreports/order-outstanding',
        ADMIN_CONSOLIDATED_OTHER_PROJECTS_EXECUTION_PLAN:"/consolidatedreports/other-projects-execution-plan",
        ADMIN_CONSOLIDATED_BUSINESS_SECTOR_WISE_EXECUTION_PLAN:"/consolidatedreports/business-sector-wise-execution-plan",
        ADMIN_CONSOLIDATED_BUSINESS_SECTOR_OTHER_PROJECTS:"/consolidatedreports/business-sector-other-projects",
        ADMIN_CONSOLIDATED_PROJECT_UNIT_WISE_PLANNING:"/consolidatedreports/project-unit-wise-planning",
        NON_INDAS_PROJECTS: "/non-indas-projects",
        ADMIN_OTHER_PROJECTS_DATE: "/other-projects-date",
        ADMIN_MASTERS: "/masters",
        ADMIN_UPDATE_REV_NO: "/update-rev-no",
        ADMIN_DELETE_REV_NO: "/delete-rev-no",
        ADMIN_MASTER_UPLOADS: "/master-uploads",
        ADMIN_DM_ANALYTICS_PROJECT_WISE_REPORT:"/dm-analytics/project-wise-report",
        ADMIN_DM_ANALYTICS_UNIT_WISE_REPORT:"/dm-analytics/unit-wise-report",
        ADMIN_DM_ANALYTICS_REPORT:"/dm-analytics/report",
        ADMIN_DM_ANALYTICS_CHARTS:"/dm-analytics/charts",
        ADMIN_DM_ANALYTICS_CRITICAL_PRODUCTS_REPORT:"/dm-analytics/critical-products-report",
        ADMIN_DM_ANALYTICS_MW_PROJECT_WISE_REPORT:"/dm-analytics/mw-project-wise-report",
};
